import { ref } from 'vue'
import { fetchCloud } from '../utilities/fetchCloud'

const CYPRESS_ORG_ID = '06fe4bd2-2315-4d55-bab2-43153895e908'

/**
 * This is a simple store that fetches the user's data from the Cloud
 */
const CloudQuery = `query CypressCloudUser {
  me {
    id
    isPayingUser
    email
    firstName
    lastName
    organizations { 
      nodes { 
        id
        name
      }
    }
  }
}
`

/**
 * `true` if the current user is logged in cloud.cypress.io, false otherwise
 */
export const isLoggedIn = ref(false)

/**
 * `true` if the user is logged in, and the account on the cloud is a paying account, false otherwise
 */
export const isPayingUser = ref(false)

/**
 * `true` if the user is logged in, and the account on the cloud has access to the Cypress org, false otherwise
 */
export const isCypressOrg = ref(false)

export const currentUser = ref<{
  id: string
  email: string
  firstName: string
  lastName: string
  company: string
  orgId: string
}>()

export const fetchPayingUser = async () => {
  if (typeof window !== 'undefined') {
    try {
      const {
        data: { me },
      } = (await fetchCloud({ query: CloudQuery })) as any

      if (me) {
        isLoggedIn.value = true
        isPayingUser.value = me.isPayingUser

        // check if the user has the Cypress org among it's organizations
        isCypressOrg.value = me.organizations?.nodes.some((org: any) => org.id === CYPRESS_ORG_ID) ?? false

        currentUser.value = {
          id: me.id,
          email: me.email,
          firstName: me.firstName,
          lastName: me.lastName,
          company:
            (me.organizations?.nodes.length ?? 0) > 0
              ? me.organizations.nodes.map((org: any) => org.name).join(', ')
              : '',
          orgId:
            (me.organizations?.nodes.length ?? 0) > 0
              ? me.organizations.nodes.map((org: any) => org.id).join(', ')
              : '',
        }
      } else {
        isLoggedIn.value = false
        isPayingUser.value = false
        isCypressOrg.value = false
      }

      // Dispatch a custom event when user data is fetched
      window.dispatchEvent(new CustomEvent('cypress:user:loaded'))
    } catch (error) {
      // if there is an error on connection,
      // we assume the user is not logged in
      // it would be easy to check on the Cloud side
    }
  }
}
